import { isIos } from "@/utils/lodash";
import { randomNum } from "@/utils/num_utils";
import LaunchHelpers from "@/utils/launch_helpers";

/**
 * 实际的status bar的高度
 * @returns
 */
export const getStatusBarHeight = () => {
  const deviceInfo = getDeviceInfo();
  const statusBar = deviceInfo && deviceInfo.status_bar_height;
  return statusBar;
};

// 判断是否是iphoneX系列的手机
export const isIphoneX = () => {
  const deviceInfo = getDeviceInfo();
  const statusBar = deviceInfo && deviceInfo.status_bar_height;
  return !!(statusBar > 20 && isIos());
};

export const getDeviceInfo = () => {
  const deviceInfo = LaunchHelpers.getLaunchData("deviceInfo");
  // console.log("deviceInfo", deviceInfo);
  return deviceInfo;
};

export const getLaunchParams = () => {
  const launchParams = LaunchHelpers.getLaunchData("launchParams");
  return launchParams;
};

/**
 * 广告 id
 */
export const getIDFA = () => {
  const deviceInfo = getDeviceInfo();
  const { advertising_identifier } = deviceInfo;
  return advertising_identifier;
};

/**
 * 获取设备id
 */
export const getDeviceId = () => {
  const deviceInfo = getDeviceInfo();
  const { device_id } = deviceInfo;
  return device_id;
};

export const getBundleId = () => {
  return getDeviceInfo().info.identifier;
};

export const getIDFV = () => {
  const deviceInfo = getDeviceInfo();
  const { device } = deviceInfo;
  const { identifier_for_vendor } = device;
  return identifier_for_vendor;
};

export const getAndroidId = () => {
  const deviceInfo = getDeviceInfo();
  const { device } = deviceInfo;
  return device && device.android_id;
};

export const getAndroidStatusbarHeight = () => {
  const deviceInfo = getDeviceInfo();
  const { status_bar_height } = deviceInfo;
  return status_bar_height;
};

export const getAndroidGaid = () => {
  return getIDFA();
};

export const getShortVersion = () => {
  return getDeviceInfo().info && getDeviceInfo().info.short_version;
};

const randomWord = (length: number) => {
  let str = "";
  // a-z 的ASCII码 97～122
  for (let i = 0; i < length; i++) {
    const pos: any = randomNum(97, 122);
    str += String.fromCharCode(pos);
  }
  return str;
};

export const getPinadDeviceId = () => {
  // TODO需要和后台联调，特别是安卓平台，ios是否直接用原生提供的device_id
  if (isIos()) {
    const deviceInfo = getDeviceInfo();
    const md5 = require("crypto-js/md5");
    console.warn("getIDFA", getIDFA());
    // 如果存在idfa且不为0，则直接md5加密，否则需要自己拼接然后md5加密
    if (getIDFA() && getIDFA() !== "00000000-0000-0000-0000-000000000000") {
      return md5(getIDFA()).toString();
    } else {
      const datajson = {
        name: deviceInfo.device.name,
        system: deviceInfo.device.system_name,
        system_version: deviceInfo.device.system_version,
        model: deviceInfo.device.model,
        localmodel: deviceInfo.device.localized_model,
        country: deviceInfo.locale.identifier,
        language: deviceInfo.locale.preferred_language,
        ip: deviceInfo.device_ip
      };
      console.warn(
        "datajson",
        datajson,
        md5(JSON.stringify(datajson)).toString()
      );
      return md5(JSON.stringify(datajson)).toString();
    }
  } else {
    return getDeviceId();
  }
};

export const getNativeCodeVersion = () => {
  return getDeviceInfo().native_code_version;
};

export const getAppPlatform = () => {
  return getDeviceInfo().app_platform;
};

export const getSystemVersion = () => {
  return getDeviceInfo().device.system_version;
};

export const getMachine = () => {
  return getDeviceInfo().machine;
};

export const getLang = () => {
  return getDeviceInfo().locale.language_code;
};

export const getNotification = () => {
  const launchParams = getLaunchParams();
  return launchParams && launchParams.hasOwnProperty("notification")
    ? launchParams.notification
    : null;
};

export const getDisplayName = () => {
  return getDeviceInfo().info.display_name;
};
